import axios from "axios";
import { BASEDOMAIN } from "@/constants/allconstants";
import { AuthConfig } from "@/utils/constants/configContants";
import { ERROR_CODES } from "@/utils/constants/constants";
import { UPDATE_SUPER_ADMIN_ERROR_MESSAGE } from "@/utils/constants/messages";
import { errorToasterMessage } from "@/utils/functions/toaster";
import { getToken } from "@/utils/functions/TokenFunction";

export const fetchInvites = async (invite_status: string, callback: any, errorCallback: any) => {
    await axios
        .get(`${BASEDOMAIN}/invitation/list?status=${invite_status}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getToken()}`,
            },
        })
        .then((response) => {
            callback(response?.data);
        })
        .catch((e) => {
            errorCallback(e?.response?.data);
        });
};

export const resendInvitation = async (data: any, callback: any, errorCallback: any) => {
    await axios
        .post(`${BASEDOMAIN}/invitation/resend`, data, AuthConfig())
        .then((response) => {
            callback(response?.data);
        })
        .catch((e) => {
            errorCallback(e?.response?.data);
            console.log(e);
        });
};
export const postInvitation = async (data: any, callback: any, errorCallback: any) => {
    await axios
        .post(`${BASEDOMAIN}/invitation`, data, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e?.response?.data);
        });
};
export const importFromAD = async () => {
    const result = await axios.post(`${BASEDOMAIN}/user/import/active-directory`, {}, AuthConfig());
    return result;
};
export const updateUser = async (id: string, data: any, callback: any, errorCallback: any) => {
    await axios
        .patch(`${BASEDOMAIN}/user/${id}`, data, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            if (e?.response?.data?.error_code === ERROR_CODES.UPDATE_SUPER_ADMIN_ERROR_CODE) {
                errorToasterMessage(UPDATE_SUPER_ADMIN_ERROR_MESSAGE);
            } else {
                errorToasterMessage(e?.response?.data?.message);
            }
            errorCallback(e?.response?.data);
        });
};
export const getUserEnvelopes = async (id: string, callback: any, errorCallback: any) => {
    axios
        .get(`${BASEDOMAIN}/envelope/list?created_by_id=${id}`, AuthConfig())
        .then((response) => {
            callback(response.data.envelopes);
        })
        .catch((e) => {
            console.log(e);
            errorCallback(e?.response.data);
        });
};
export const getUserById = async (id: string, callback: any, errorCallback: any) => {
    await axios
        .get(`${BASEDOMAIN}/user/${id}`, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            console.log(e);
            errorCallback(e?.response);
        });
};
export const getLoggedInUser = async (callback: any, errorCallback: any) => {
    await axios
        .get(`${BASEDOMAIN}/user`, AuthConfig())
        .then((response) => {
            callback(response.data);
        })
        .catch((e) => {
            console.log(e);
            errorCallback(e?.response);
        });
};
export const fetchUsers = async (pageNo: number | null, dataLength: number | null, sorting: any, filter: any, searchItem: string | null, callback: any, errorCallback: any) => {
    let url = searchItem ? `${BASEDOMAIN}/user/list?offset=${dataLength ? dataLength * (pageNo || 1) - dataLength : 0}&limit=${dataLength}&sort=${JSON.stringify(sorting)}&search=${searchItem}` : `${BASEDOMAIN}/user/list?offset=${dataLength ? dataLength * (pageNo || 1) - dataLength : 0}&limit=${dataLength}&sort=${JSON.stringify(sorting)}`;

    if (filter) {
        if (filter.createdAtStart) {
            url += `&created_on_or_after=${filter.createdAtStart}`;
        }
        if (filter.createdAtEnd) {
            url += `&created_on_or_before=${filter.createdAtEnd}`;
        }
        if (filter.lastLoginAtStart) {
            url += `&last_logged_on_or_after=${filter.lastLoginAtStart}`;
        }
        if (filter.lastLoginAtEnd) {
            url += `&last_logged_on_or_before=${filter.lastLoginAtEnd}`;
        }
        if (filter.status) {
            url += `&is_active=${filter.status.value}`;
        }
        if (filter.role) {
            url += `&roles=${filter.role.value}`;
        }
        if (filter.group) {
            url += `&groups=${filter.group.value}`;
        }
        if (filter.is_verified) {
            url += `&is_verified=${filter.is_verified}`;
        }
        if (filter.is_reported) {
            url += `&is_reported=${filter.is_reported}`
        }
    }

    await axios
        .get(url, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e?.response?.data);
        });
};
export const updateUserById = async (id: string, data: any, callback: any, errorCallback: any) => {
    await axios
        .patch(`${BASEDOMAIN}/user/${id}`, data, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e?.response);
        });
};
export const fetchUserAsAdmin = async (pageNo: number, dataLength: number, sorting: any, filter: any, searchItem: string | null, callback: any, errorCallback: any) => {
    let url = searchItem ? `${BASEDOMAIN}/user/list?role=admin&offset=${dataLength * pageNo - dataLength}&limit=${dataLength}&sort=${JSON.stringify(sorting)}&search=${searchItem}` : `${BASEDOMAIN}/user/list?role=admin&offset=${dataLength * pageNo - dataLength}&limit=${dataLength}&sort=${JSON.stringify(sorting)}`;
    if (filter) {
        if (filter.createdAtStart) {
            url += `&created_on_or_after=${filter.createdAtStart}`;
        }
        if (filter.createdAtEnd) {
            url += `&created_on_or_before=${filter.createdAtEnd}`;
        }
        if (filter.lastLoginAtStart) {
            url += `&last_logged_on_or_after=${filter.lastLoginAtStart}`;
        }
        if (filter.lastLoginAtEnd) {
            url += `&last_logged_on_or_before=${filter.lastLoginAtEnd}`;
        }
        if (filter.status) {
            url += `&is_active=${filter.status.value}`;
        }
        if (filter.role) {
            url += `&roles=${filter.role.value}`;
        }
        if (filter.group) {
            url += `&groups=${filter.group.value}`;
        }
    }
    await axios
        .get(url, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e?.response);
        });
};

export const createSharedAccess = async (data: any) => {
    return await axios.post(`${BASEDOMAIN}/user/admin/account-delegation`, data, AuthConfig())
}

export const fetchSharedAccessUsersForMyAccount = async (id: string, search: string) => {
    let url = `${BASEDOMAIN}/user/account-delegations/list?id=${id}`;
    if (search) {
        url = url + `&search=${search}`;
    }
    return await axios.get(url, AuthConfig());
};

export const fetchSharedAccessUsersForOther = async (id: string, search: string) => {
    let url = `${BASEDOMAIN}/user/account-delegations/delegate/${id}`;
    if (search) {
        url = `${url}?search=${search}`;
    }
    return await axios.get(url, AuthConfig());
};

export const deleteAccountDelegation = async (id: string, delegatorId: string) => {
    return await axios.delete(`${BASEDOMAIN}/user/account-delegations/delegate/${id}?user_id=${delegatorId}`, AuthConfig());
};

export const fetchADUsers = async (pageNo: number, dataLength: number, sorting: any, filter: any, searchItem: string | null, callback: any, errorCallback: any) => {
    let url = searchItem ? `${BASEDOMAIN}/directory-contact/list?&offset=${dataLength * pageNo - dataLength}&limit=${dataLength}&search=${searchItem}` : `${BASEDOMAIN}/directory-contact/list?offset=${dataLength * pageNo - dataLength}&limit=${dataLength}`;

    if (filter.group) {
        url += `&group=${filter.group}`;
    }

    if (filter.source) {
        url += `&source=${filter.source}`;
    }

    axios
        .get(url, AuthConfig())
        .then((res) => {
            callback(res);
        })
        .catch((err) => console.log(err));
};

export const validateLoggedInUser = async (data: any, callback: any, errorCallback: any) => {
    axios.post(`${BASEDOMAIN}/user/verify-account`, data, AuthConfig())
        .then((res: any) => {
            callback(res)
        })
        .catch((err: any) => {
            errorCallback(err)
        })
}

export const sendUpdateEmailCode = async (id: string, data: any, callBack: any, errCallBack: any) => {
    await axios.post(`${BASEDOMAIN}/user/send-update-email-code/${id}`, data, AuthConfig())
        .then((res) => {
            callBack(res)
        })
        .catch((err) => {
            errCallBack(err?.response)
        })
}

export const verifyCodeAndUpdateEmail = async (id: String, data: any, callBack: any, errCallBack: any) => {
    await axios.post(`${BASEDOMAIN}/user/${id}/update-email`, data, AuthConfig())
        .then((res) => {
            callBack(res?.data)
        })
        .catch((err) => {
            errCallBack(err)
        })
}

export const sendCodeToVerifyCurrentEmail = async (data: any, callBack: any, errCallBack: any) => {
    await axios.post(`${BASEDOMAIN}/user/request-email-verification`, data, AuthConfig())
    .then((res) => {
        callBack(res?.data)
    })
    .catch((err) => {
        errCallBack(err?.response)
    })
}

export const validateUserCurrentEmail = async (data: any, callBack: any, errCallBack: any) => {
    await axios.post(`${BASEDOMAIN}/user/verify-email-code`, data, AuthConfig())
    .then((res) => {
        callBack(res?.data)
    })
    .catch((err) => {
        errCallBack(err?.response)
    })
}

export const suspendUser = async ({ user_id, reason }: any, callBack: any, errCallBack: any) => {
    await axios.patch(`${BASEDOMAIN}/user/suspend-user/${user_id}`, { reason }, AuthConfig())
    .then((res) => {
        callBack(res?.data)
    })
    .catch((err) => {
        errCallBack(err?.response)
    })
}

export const unsuspendUser = async ({ user_id }: any, callBack: any, errCallBack: any) => {
    await axios.patch(`${BASEDOMAIN}/user/unsuspend-user/${user_id}`, {}, AuthConfig())
    .then((res) => {
        callBack(res?.data)
    })
    .catch((err) => {
        errCallBack(err?.response)
    })
}

export const markAsSafe = async (id: string, callBack: any, errCallBack: any) => {
    await axios.patch(`${BASEDOMAIN}/user/${id}/mark-safe`, {}, AuthConfig())
    .then((res) => {
        callBack(res?.data)
    })
    .catch((err) => {
        errCallBack(err?.response)
    })
}

export const contactUser = async (id: string, data: any, callBack: any, errCallBack: any) => {
    await axios.post(`${BASEDOMAIN}/user/${id}/contact`, data, AuthConfig())
    .then((res) => {
        callBack(res?.data)
    })
    .catch((err) => {
        errCallBack(err?.response)
    })
}

